export default __webpack_public_path__ + "static/media/aboutus.227b1866.png";